// src/SellPureWeight.js

import React, { useState } from 'react';
import axios from 'axios';
import baseURL from './baseUrl';
const SellPureWeight = () => {
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${baseURL}/api/transactions/sell/pure-weight`, {
        amount: parseFloat(amount),
        note,
      });

      setMessage(response.data.message); // Set success message
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 200
        setMessage(error.response.data.message);
      } else {
        // Network error or no response
        setMessage('An error occurred while selling pure weight');
      }
    }
  };

  return (
    <div className="container mt-4">
      <h2>Sell Pure Weight</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="amount" className="form-label">Amount (in kg)</label>
          <input
            type="number"
            className="form-control"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="note" className="form-label">Note (optional)</label>
          <textarea
            className="form-control"
            id="note"
            rows="3"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          ></textarea>
        </div>
        <button type="submit" className="btn btn-primary">Sell Pure Weight</button>
      </form>
      {message && <div className="mt-3 alert alert-info">{message}</div>}
    </div>
  );
};

export default SellPureWeight;
